<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout wrap>
          <v-flex text-xs-left xs12 md8 v-if="showLabelReportList || showLabelReportOrderList || showEstimateList">
            <v-btn flat @click="showLabelReports" class="bw-5" :disabled="isLabelReportView">Label reports</v-btn>
            <v-btn flat @click="showLabelReportTasks" class="bw-6" :disabled="isTaskView">Label report tasks</v-btn>
            <v-btn flat @click="showLabelReportEstimates" class="bw-4" :disabled="isEstimateView" style="margin-right: 50px;">Estimates</v-btn>
            <v-btn flat @click="openTrackLabelDialog" class="bw-5" v-if="showLabelReportList">Track label no.</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 md4 v-if="showLabelReportList || showLabelReportOrderList || showEstimateList">
            <v-btn flat @click="print" class="bw-3" v-if="showLabelReportList">Print</v-btn>
            <v-btn flat @click="create" class="bw-7" v-if="showLabelReportList">Create new label report</v-btn>
            <v-btn flat @click="confirmBulkApprove" class="bw-4" :disabled="bulkApproveDisabled" v-if="showLabelReportOrderList">Approve</v-btn>
            <v-btn flat @click="createOrder" class="bw-8" v-if="showLabelReportOrderList">Create new label report task</v-btn>
            <v-btn flat @click="createEstimate" class="bw-7" v-if="showEstimateList">Create new estimate</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 v-if="currentLabelReport">
            <v-btn flat @click="save" :disabled="saveButtonDisabled" class="bw-3">Save</v-btn>
            <v-btn flat @click="addSequence" :disabled="addSequenceButtonDisabled" class="bw-5">Add sequence</v-btn>
            <v-btn flat @click="confirmDeleteDialog = true" v-if="canDelete" class="bw-3">Delete</v-btn>
            <v-btn flat @click="cancel" class="bw-3">{{ currentLabelReport.id > 0 ? 'Close' : 'Cancel' }}</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 v-if="currentLabelReportOrder">
            <v-btn flat @click="saveOrder" :disabled="saveOrderButtonDisabled" class="bw-3">Save</v-btn>
            <v-btn flat @click="confirmDeleteOrderDialog = true" v-if="canDeleteOrder" class="bw-3">Delete</v-btn>
            <v-btn flat @click="cancelOrder" class="bw-3">{{ currentLabelReportOrder.id > 0 ? 'Close' : 'Cancel' }}</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 v-if="currentLabelReportTask">
            <v-btn flat @click="approveTask" :disabled="approveButtonDisabled" class="bw-3" style="float: left;">Approve</v-btn>
            <v-btn flat @click="unlockTask" :disabled="unlockButtonDisabled" class="bw-3" style="float: left;">Unlock</v-btn>
            <v-btn flat @click="save" :disabled="saveButtonDisabled" class="bw-3">Save</v-btn>
            <v-btn flat @click="addSequence" :disabled="addSequenceButtonDisabled" class="bw-5">Add sequence</v-btn>
            <v-btn flat @click="cancelTask" class="bw-3">Close</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 v-if="currentLabelReportEstimate">
            <v-btn flat @click="createEstimates" :disabled="createEstimatesButtonDisabled" class="bw-3" v-if="!hasEstimates">Create</v-btn>
            <v-btn flat @click="saveEstimate" :disabled="saveButtonDisabled" class="bw-3" v-if="hasEstimates">Save</v-btn>
            <v-btn flat @click="addEstimate" class="bw-5" v-if="hasEstimates">Add estimate</v-btn>
            <v-btn flat @click="confirmDeleteEstimateDialog = true" v-if="canDeleteLabelReportEstimate" class="bw-3">Delete</v-btn>
            <v-btn flat @click="cancelEstimate" class="bw-3">{{ newLabelReportEstimate ? 'Close' : 'Cancel' }}</v-btn>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 6px;" v-if="showLabelReportList">
            <v-select :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object @change="loadLabelReports" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 6px;" v-if="showLabelReportList">
            <v-select :items="filteredFilterFields" v-model="filterField" item-text="address.nameAndText" prepend-icon="a-address" return-object @change="loadLabelReports" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 6px;" v-if="showLabelReportList">
            <v-autocomplete :items="filterCategories" v-model="filterCategory" item-text="displayLabel" prepend-icon="a-trees" return-object @change="loadLabelReports" class="categoryFilter">
              <template slot="selection" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
              <template slot="item" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 6px;" v-if="showLabelReportList">
            <v-select :items="filterLabellers" v-model="filterLabeller" item-text="fullName" prepend-icon="fa-user" return-object @change="loadLabelReports" class="labellerFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showLabelReportOrderList">
            <v-select :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object @change="loadLabelReportOrders" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showLabelReportOrderList">
            <v-select :items="filterFields" v-model="filterField" item-text="address.nameAndText" prepend-icon="a-address" return-object @change="loadLabelReportOrders" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showLabelReportOrderList">
            <v-select :items="filterLabellers" v-model="filterLabeller" item-text="fullName" prepend-icon="fa-user" return-object @change="loadLabelReportOrders" class="labellerFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showEstimateList">
            <v-select :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object @change="loadLabelReportEstimates" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showEstimateList">
            <v-select :items="filterFields" v-model="filterField" item-text="address.nameAndText" prepend-icon="a-address" return-object @change="loadLabelReportEstimates" class="fieldFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="showEstimateList">
            <v-autocomplete :items="filterCategories" v-model="filterCategory" item-text="displayLabel" prepend-icon="a-trees" return-object @change="loadLabelReportEstimates" class="categoryFilter">
              <template slot="selection" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
              <template slot="item" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="showLabelReportList">
        <v-layout :style="'max-height: calc(100vh - 190px' + (trackingMode ? ' - 40px' : '') +');'">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="trackingMode ? trackingHeaders : headers" :items="labelReportsWithTotals" hide-actions no-data-text="No label reports found" ref="labelReports" class="labelReportTable">
              <template v-slot:items="props">
                <tr @click="selectLabelReportRow(props.item)" class="selectable" v-if="props.item.id">
                  <td class="text-xs-left">{{ props.item.newSupplier ? props.item.supplier.name : '' }}</td>
                  <td class="text-xs-left">{{ props.item.newField ? props.item.field.address.nameAndText : '' }}</td>
                  <td class="text-xs-left category">
                    <div v-if="props.item.category.color && !(props.item.category.color.secondColor && props.item.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + props.item.category.color.color + ';'"></div>
                    <div v-if="props.item.category.color && props.item.category.color.secondColor && props.item.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + props.item.category.color.color + ', #' + props.item.category.color.color + ' 3px, #' + props.item.category.color.secondColor + ' 3px, #' + props.item.category.color.secondColor + ' 6px);'"></div>
                  </td>
                  <td class="text-xs-left">
                    <div style="display: inline;">{{ props.item.category.displayLabel }}</div>
                  </td>
                  <td class="text-xs-left">{{ props.item.user ? props.item.user.fullName : '' }}</td>
                  <td class="text-xs-right" style="width: 100px !important; padding-right: 15px !important;" v-if="!trackingMode">{{ props.item.total.toLocaleString() }}</td>
                </tr>
                <tr v-if="props.item.type === 'subTotal' && !trackingMode" class="subTotal">
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right" style="height: 23px !important; padding-bottom: 12px !important;">Subtotal</td>
                  <td class="text-xs-right" style="height: 23px !important; padding-bottom: 12px !important; width: 100px !important; padding-right: 15px !important;">{{ props.item.value.toLocaleString() }}</td>
                </tr>
                <tr v-if="props.item.type === 'total' && !trackingMode" class="total">
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right">&nbsp;</td>
                  <td class="text-xs-right" style="height: 23px !important; padding-top: 12px !important;">Total</td>
                  <td class="text-xs-right" style="height: 23px !important; padding-top: 12px !important; width: 100px !important; padding-right: 15px !important;">{{ props.item.value.toLocaleString() }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-3 v-if="showLabelReportList && trackingMode" >
        <v-layout>
          <v-flex xs12 text-xs-right>
            <v-btn flat @click="loadLabelReports" class="bw-5" v-if="showLabelReportList">End tracking</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="showLabelReportOrderList" >
        <v-layout style="max-height: calc(100vh - 190px);">
          <v-flex text-xs-right style="overflow-y: auto;">
            <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; margin-bottom: 20px;">
              <v-data-table :headers="taskHeaders" :items="labelReportTasks" hide-actions class="labelReportTable" v-if="labelReportTasks.length > 0">
                <template v-slot:items="props">
                  <tr :class="'selectable ' + (props.item.category ? 'awaitingApproval' : 'awaitingApprovalAndMissingCategory')">
                    <td class="text-xs-left labelReportTask" style="padding: 0 0 0 5px !important; width: 30px; background-color: rgba(255, 255, 255, 0.5);">
                      <v-checkbox color="#004d40" v-model="labelReportTasksSelected[props.index].selected" v-if="props.item.category"/>
                    </td>
                    <td class="text-xs-left" @click="selectLabelReportTaskRow(props.item)" >{{ props.item.supplier.name }}</td>
                    <td class="text-xs-left" @click="selectLabelReportTaskRow(props.item)">{{ props.item.field.address.nameAndText }}</td>
                    <td class="text-xs-left" @click="selectLabelReportTaskRow(props.item)">
                      {{ props.item.user.fullName }}
                    </td>
                    <td class="text-xs-left" @click="selectLabelReportTaskRow(props.item)">
                      <div v-html="props.item.category.displayLabelWithIcon" v-if="props.item.category"></div>
                      <div v-html="props.item.categoryName" v-if="!props.item.category"></div>
                    </td>
                    <td class="text-xs-right" @click="selectLabelReportTaskRow(props.item)" style="width: 80px;">{{ props.item.total.toLocaleString() }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
            <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px;">
              <v-data-table :headers="orderHeaders" :items="labelReportOrders" hide-actions no-data-text="No label report tasks found" class="labelReportTable">
                <template v-slot:items="props">
                  <tr @click="selectLabelReportOrderRow(props.item)" :class="labelReportOrderRowClass(props.item)">
                    <td class="text-xs-left" style="width: 20%;">{{ props.item.supplier.name }}</td>
                    <td class="text-xs-left" style="width: 30%;">{{ props.item.field.address.nameAndText }}</td>
                    <td class="text-xs-left" style="width: 30%;">
                      <div v-for="(category, i) in props.item.categories" v-bind:key="'cat_' + i">
                        <div v-html="category.displayLabelWithIcon"></div>
                      </div>
                    </td>
                    <td class="text-xs-left" style="width: 20%;">
                      <div v-for="(user, i) in props.item.users" v-bind:key="'usr_' + i">
                        <div class="ml">
                          {{ user.fullName }}
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="showEstimateList" >
        <v-layout style="max-height: calc(100vh - 190px);">
          <v-flex text-xs-right style="overflow-y: auto;">
            <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px;">
              <v-data-table :headers="estimateHeaders" :items="labelReportEstimatesWithTotals" hide-actions no-data-text="No label report estimates found" class="labelReportTable">
                <template v-slot:items="props">
                  <tr @click="selectLabelReportEstimateRow(props.item)" :class="labelReportEstimateRowClass(props.item)" v-if="props.item.supplier">
                    <td class="text-xs-left" style="width: 30%;">{{ props.item.supplier.name }}</td>
                    <td class="text-xs-left" style="width: 30%;">{{ props.item.field.address.nameAndText }}</td>
                    <td class="text-xs-left">
                      <div v-for="(labelReportEstimate, i) in props.item.labelReportEstimates" v-bind:key="'cat_' + i">
                        <div v-html="labelReportEstimate.category.displayLabelWithIcon"></div>
                      </div>
                    </td>
                    <td class="text-xs-right" style="width: 180px;">
                      <div v-for="(labelReportEstimate, i) in props.item.labelReportEstimates" v-bind:key="'est_' + i">
                        <div v-html="labelReportEstimate.estimate"></div>
                      </div>
                      <div style="width: 100%;">
                        <div class="subTotal" style="display: inline-flex; float: left;">Subtotal</div>
                        <div class="subTotalValue" style="display: inline-flex; float: right; padding-left: 30px;">{{ getLabelReportEstimateTotal(props.item).toLocaleString() }}</div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="props.item.type === 'total'" class="total">
                    <td class="text-xs-right">&nbsp;</td>
                    <td class="text-xs-right">&nbsp;</td>
                    <td class="text-xs-right" style="height: 23px !important; padding-top: 12px !important;">Total</td>
                    <td class="text-xs-right" style="height: 23px !important; padding-top: 12px !important; width: 100px !important; padding-right: 10px !important;">{{ props.item.value.toLocaleString() }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentLabelReport">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Label report">
                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Supplier</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-autocomplete :items="suppliers" v-model="currentSupplier" item-text="name" return-object @change="loadFields">
                    <template slot="selection" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Field</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-autocomplete :items="fields" v-model="currentLabelReport.field" item-text="address.nameAndText" return-object>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Category</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-autocomplete :items="categories" v-model="currentLabelReport.category" item-text="displayLabel" return-object>
                    <template slot="selection" slot-scope="data">
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Labeller</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-autocomplete :items="labellerUsersWithEmpty" v-model="currentLabelReport.user" item-text="fullName" return-object>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.fullName }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.fullName }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Adjustment</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-text-field v-model="currentLabelReport.adjustment" class="right-align" style="max-width: 100px;"/>
                </v-flex>

                <v-flex xs12 style="min-height: 35px;">
                  <v-container fluid py-4 px-0>
                    <v-layout wrap v-for="(sequence, i) in currentLabelReport.sequences" v-bind:key="sequence.id">
                      <v-flex xs12 sm4 lg2 style="height: 35px;">
                        <v-label>Sequence #{{ i+1 }}</v-label>
                      </v-flex>
                      <v-flex xs12 sm8 lg10 style="height: 35px;">
                        <table>
                          <tr>
                            <td style="padding-right: 20px;">
                              <v-text-field v-model="sequence.sequenceStart" class="right-align" style="max-width: 160px;"/>
                            </td>
                            <td>&rightarrow;</td>
                            <td style="padding-left: 20px;">
                              <v-text-field v-model="sequence.sequenceEnd" class="right-align" style="max-width: 160px;"/>
                            </td>
                            <td style="padding-left: 10px; width: 35px;">
                              <v-icon v-if="canDeleteSequence(i)" @click="deleteSequence(i)" title="Delete">delete</v-icon>
                            </td>
                          </tr>
                        </table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Total</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  {{ total }}
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentLabelReportOrder">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Label report task">
                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Supplier</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px; padding-bottom: 50px;">
                  <v-autocomplete :items="suppliers" v-model="currentSupplier" item-text="name" return-object @change="loadFields">
                    <template slot="selection" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Field</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px; padding-bottom: 50px;">
                  <v-autocomplete :items="fields" v-model="currentLabelReportOrder.field" item-text="address.nameAndText" return-object>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Categories</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; padding-bottom: 20px;">
                  <v-autocomplete :items="categories" v-model="currentLabelReportOrder.categories" item-text="displayLabel" multiple return-object>
                    <template slot="selection" slot-scope="data">
                      <div style="padding-right: 30px;">
                        <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'display: inline-block; margin: 5px 10px 1px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                        <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'display: inline-block; margin: 5px 10px 1px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                        <div style="display: inline-block; vertical-align: top; padding-top: 5px;">{{ data.item.displayLabel }}</div>
                      </div>
                    </template>
                    <template slot="item" slot-scope="data">
                      <div style="width: 30px; padding-right: 10px !important;">
                        <v-checkbox :input-value="itemSelected(currentLabelReportOrder.categories, data.item)" color="primary" style="width: 30px;"/>
                      </div>
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Labellers</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-autocomplete :items="labellerUsers" v-model="currentLabelReportOrder.users" item-text="fullName" multiple return-object/>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentLabelReportTask">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Label report task">
                <v-flex xs12 sm4 lg2 style="padding-top: 0;">
                  <v-label>Supplier</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="padding-top: 2px;">
                  <div v-html="currentLabelReportTask.supplier.name"></div>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="padding-top: 0;">
                  <v-label>Field</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="padding-top: 2px;">
                  <div v-html="currentLabelReportTask.field.address.nameAndText"></div>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="padding-top: 0;">
                  <v-label>Category</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="padding-top: 2px;">
                  <div v-html="currentLabelReportTask.category.displayLabelWithIcon" v-if="!currentLabelReportTask.categoryName"></div>
                  <div v-html="currentLabelReportTask.categoryName" v-if="currentLabelReportTask.categoryName"></div>
                  <v-autocomplete :items="categories" v-model="currentLabelReportTask.category" item-text="displayLabel" return-object v-if="currentLabelReportTask.categoryName">
                    <template slot="selection" slot-scope="data">
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="padding-top: 0;">
                  <v-label>Labeller</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="padding-top: 2px;">
                  <div v-html="currentLabelReportTask.user.fullName"></div>
                </v-flex>

                <v-flex xs12 style="min-height: 35px;">
                  <v-container fluid py-4 px-0>
                    <v-layout wrap v-for="(sequence, i) in currentLabelReportTask.sequences" v-bind:key="sequence.id">
                      <v-flex xs12 sm4 lg2 style="height: 35px;">
                        <v-label>Sequence #{{ i+1 }}</v-label>
                      </v-flex>
                      <v-flex xs12 sm8 lg10 style="height: 35px;">
                        <table>
                          <tr>
                            <td style="padding-right: 20px;">
                              <v-text-field v-model="sequence.sequenceStart" class="right-align" style="max-width: 160px;"/>
                            </td>
                            <td>&rightarrow;</td>
                            <td style="padding-left: 20px;">
                              <v-text-field v-model="sequence.sequenceEnd" class="right-align" style="max-width: 160px;"/>
                            </td>
                            <td style="padding-left: 10px; width: 35px;">
                              <v-icon v-if="canDeleteSequence(i)" @click="deleteSequence(i)" title="Delete">delete</v-icon>
                            </td>
                          </tr>
                        </table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Total</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  {{ total }}
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentLabelReportEstimate">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Label report estimate">
                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Supplier</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <div v-if="currentLabelReportEstimate.id > 0">{{ currentSupplier.name }}</div>
                  <v-autocomplete :items="suppliers" v-model="currentSupplier" item-text="name" return-object v-if="!currentLabelReportEstimate.id" @change="loadFields">
                    <template slot="selection" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.name }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Field</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <div v-if="currentLabelReportEstimate.id > 0">{{ currentLabelReportEstimate.field.address.nameAndText }}</div>
                  <v-autocomplete :items="fieldsWithoutEstimates" v-model="currentLabelReportEstimate.field" item-text="address.nameAndText" return-object v-if="!currentLabelReportEstimate.id">
                    <template slot="selection" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.address.nameAndText }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;" v-if="!hasEstimates">
                  <v-label>Categories</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;" v-if="!hasEstimates">
                  <v-autocomplete :items="categories" v-model="selectedCategories" item-text="displayLabel" multiple return-object>
                    <template slot="selection" slot-scope="data">
                      <div style="padding-right: 30px;">
                        <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'display: inline-block; margin: 5px 10px 1px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                        <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'display: inline-block; margin: 5px 10px 1px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                        <div style="display: inline-block; vertical-align: top; padding-top: 5px;">{{ data.item.displayLabel }}</div>
                      </div>
                    </template>
                    <template slot="item" slot-scope="data">
                      <div style="width: 30px; padding-right: 10px !important;">
                        <v-checkbox :input-value="itemSelected(selectedCategories, data.item)" color="primary" style="width: 30px;"/>
                      </div>
                      <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                      <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                      {{ data.item.displayLabel }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 style="height: 35px;" v-if="hasEstimates">
                  <v-label>Estimates</v-label>
                </v-flex>

                <template v-for="(labelReportEstimate, i) in currentLabelReportEstimate.labelReportEstimates" v-if="hasEstimates">
                  <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px; padding-right: 30px;" v-bind:key="'cat_' + i">
                    <v-autocomplete :items="categories" v-model="labelReportEstimate.category" item-text="displayLabel" return-object>
                      <template slot="selection" slot-scope="data">
                        <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                        <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                        {{ data.item.displayLabel }}
                      </template>
                      <template slot="item" slot-scope="data">
                        <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                        <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                        {{ data.item.displayLabel }}
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm4 lg2 style="padding-top: 5px; height: 35px;" v-bind:key="'est_' + i">
                    <table class="noPadding">
                      <tr>
                        <td>
                          <v-text-field v-model="labelReportEstimate.estimate"/>
                        </td>
                        <td style="padding-left: 8px;">
                          <v-icon v-if="canDeleteEstimate(i)" @click="deleteEstimate(i)" title="Delete">delete</v-icon>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </template>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete label report</v-card-title>
        <v-card-text v-if="currentLabelReport">Are you sure you want to delete this label report?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.delete">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDeleteOrderDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Delete label report task</v-card-title>
        <v-card-text v-if="currentLabelReportOrder">Are you sure you want to delete this label report task?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteOrder">Yes</v-btn>
          <v-btn flat @click="confirmDeleteOrderDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmBulkApproveDialog" persistent width="450">
      <v-card pa-5>
        <v-card-title class="headline">Bulk approve</v-card-title>
        <v-card-text>Are you sure you want to approve the selected label reports?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.bulkApprove">Yes</v-btn>
          <v-btn flat @click="confirmBulkApproveDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDeleteEstimateDialog" persistent width="550">
      <v-card pa-5>
        <v-card-title class="headline">Delete estimate</v-card-title>
        <v-card-text v-if="currentLabelReportEstimate && currentLabelReportEstimate.field && currentLabelReportEstimate.field.address">Are you sure you want to delete all estimates for field<br/>"{{ currentLabelReportEstimate.field.address.nameAndText }}"?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteEstimates">Yes</v-btn>
          <v-btn flat @click="confirmDeleteEstimateDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="trackLabelDialog" persistent width="500">
      <v-card pa-5>
        <v-card-title class="headline">Track label no.</v-card-title>
        <v-card-text>
          <v-container fluid py-0 px-3>
            <v-layout wrap>
              <v-flex xs4 style="line-height: 36px;">Category</v-flex>
              <v-flex xs8>
                <v-autocomplete :items="categories" v-model="trackLabelCategory" item-text="displayLabel" return-object class="trackLabelNoCategory">
                  <template slot="selection" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs4 style="line-height: 36px;">Label no.</v-flex>
              <v-flex xs8>
                <v-text-field v-model="trackLabelNo" style="width: 150px;"/>
              </v-flex>
              <v-flex xs12 text-xs-center v-if="trackLabelNoError" class="error-message" style="font-weight: bold; padding-top: 5px;">
                {{ trackLabelNoError }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat class="bw-3" @click="trackLabel" :disabled="!isValidTracking">Track</v-btn>
          <v-btn flat class="bw-3" @click="trackLabelDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import PanelColumn2 from '../components/PanelColumn2'
import NumberUtil from '@/assets/javascript/numberutil'
import axios from 'axios'

export default {
  name: 'LabelReport',
  components: { Header, Sidebar, Footer, Panel, PanelColumn, PanelColumn2 },
  data () {
    return {
      search: '',
      headers: [
        { text: 'Supplier', value: 'supplier.name', sortable: false },
        { text: 'Field', value: 'field.address.nameAndText', sortable: false },
        { text: '', sortable: false },
        { text: 'Category', value: 'category.label', sortable: false },
        { text: 'Labeller', value: 'user.fullName', sortable: false },
        { text: 'Amount', value: 'total', sortable: false, align: 'end', class: 'labelReportAmountHeader' }
      ],
      trackingHeaders: [
        { text: 'Supplier', value: 'supplier.name', sortable: false },
        { text: 'Field', value: 'field.address.nameAndText', sortable: false },
        { text: '', sortable: false },
        { text: 'Category', value: 'category.label', sortable: false },
        { text: 'Labeller', value: 'user.fullName', sortable: false }
      ],
      orderHeaders: [
        { text: 'Supplier', value: 'supplier.name', sortable: false },
        { text: 'Field', value: 'field.address.nameAndText', sortable: false },
        { text: 'Categories', value: '', sortable: false },
        { text: 'Labellers', value: '', sortable: false }
      ],
      taskHeaders: [
        { text: '', value: '', sortable: false },
        { text: 'Supplier', value: 'supplier.name', sortable: false },
        { text: 'Field', value: 'field.address.nameAndText', sortable: false },
        { text: 'Labeller', value: '', sortable: false },
        { text: 'Category', value: '', sortable: false },
        { text: 'Amount', value: '', sortable: false, align: 'end' }
      ],
      estimateHeaders: [
        { text: 'Supplier', value: 'supplier.name', sortable: false },
        { text: 'Field', value: 'field.address.nameAndText', sortable: false },
        { text: 'Categories', value: '', sortable: false },
        { text: 'Amount', value: '', sortable: false, align: 'end' }
      ],
      labelReports: [],
      labelReportsWithTotals: [],
      labelReportOrders: [],
      labelReportTasks: [],
      labelReportTasksSelected: [],
      labelReportEstimates: [],
      categories: [],
      suppliers: [],
      fields: [],
      labellerUsers: [],
      labellerUsersWithEmpty: [],
      filterCategories: [],
      filterCategory: { id: 0 },
      filterSuppliers: [],
      filterSupplier: { id: 0 },
      filterFields: [],
      filterField: { id: 0 },
      filterLabellers: [],
      filterLabeller: { id: 0 },
      view: 'LABEL_REPORT',
      currentSupplier: null,
      currentLabelReport: null,
      currentLabelReportOrder: null,
      currentLabelReportTask: null,
      currentLabelReportEstimate: null,
      newLabelReportEstimate: false,
      confirmDeleteDialog: false,
      confirmDeleteOrderDialog: false,
      confirmDeleteEstimateDialog: false,
      confirmBulkApproveDialog: false,
      trackLabelDialog: false,
      trackLabelCategory: null,
      trackLabelNo: null,
      trackLabelNoError: null,
      trackingMode: false,
      selectedCategories: []
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'label_report' })
    this.loadLabelReports()
    this.loadFilterCategories()
    this.loadFilterSuppliers()
    this.loadFilterFields()
    this.loadFilterLabellers()
    this.loadSuppliers()
    this.loadCategories()
    this.loadLabellers()
  },
  computed: {
    isLabelReportView: function () {
      return this.view === 'LABEL_REPORT'
    },
    isTaskView: function () {
      return this.view === 'TASK'
    },
    isEstimateView: function () {
      return this.view === 'ESTIMATE'
    },
    showLabelReportList: function () {
      return !this.currentLabelReport && !this.currentLabelReportOrder && this.isLabelReportView
    },
    showLabelReportOrderList: function () {
      return !this.currentLabelReport && !this.currentLabelReportOrder && !this.currentLabelReportTask && this.isTaskView
    },
    showEstimateList: function () {
      return !this.currentLabelReportEstimate && this.isEstimateView
    },
    users: function () {
      return this.$store.state.user.users
    },
    filteredFilterFields: function () {
      return this.filterSupplier && this.filterSupplier.id > 0 ? this.filterFields.filter(f => f.id === 0 || f.supplierId === this.filterSupplier.id) : this.filterFields
    },
    saveButtonDisabled: function () {
      if (this.currentLabelReport) {
        return !this.currentLabelReport || this.currentLabelReport.category.id === 0 || this.currentLabelReport.field.id === 0 || (!this.sequencesComplete && !this.hasValidAdjustment)
      } else if (this.currentLabelReportTask) {
        return !(this.sequencesComplete || this.currentLabelReportTask.sequences.length === 0)
      } else if (this.currentLabelReportEstimate) {
        return !this.currentLabelReportEstimate || !this.estimatesComplete || (!this.currentLabelReportEstimate.id && !this.currentSupplier)
      }
      return true
    },
    createEstimatesButtonDisabled: function () {
      return !(this.currentLabelReportEstimate && this.currentSupplier && this.currentSupplier.id > 0 && this.currentLabelReportEstimate.field && this.currentLabelReportEstimate.field.id > 0 && this.selectedCategories.length > 0)
    },
    canApprove: function () {
      return this.currentLabelReportTask && this.sequencesComplete
    },
    approveButtonDisabled: function () {
      return !(this.currentLabelReportTask && this.currentLabelReportTask.category && (this.sequencesComplete || this.currentLabelReportTask.sequences.length === 0))
    },
    unlockButtonDisabled: function () {
      return !(this.currentLabelReportTask && (this.sequencesComplete || this.currentLabelReportTask.sequences.length === 0))
    },
    addSequenceButtonDisabled: function () {
      return false
    },
    canDelete: function () {
      return this.currentLabelReport && this.currentLabelReport.id > 0
    },
    sequencesComplete: function () {
      let complete = false
      let sequenceContainer = this.currentLabelReport ? this.currentLabelReport : this.currentLabelReportTask ? this.currentLabelReportTask : null
      if (sequenceContainer && sequenceContainer.sequences && sequenceContainer.sequences.length > 0) {
        complete = true
        for (let seq of sequenceContainer.sequences) {
          let start = NumberUtil.isZeroOrPositiveInteger(seq.sequenceStart) ? Number(seq.sequenceStart) : -1
          let end = NumberUtil.isZeroOrPositiveInteger(seq.sequenceEnd) ? Number(seq.sequenceEnd) : -1
          if (!(start >= 0 && end >= start)) {
            complete = false
            break
          }
        }
      }
      return complete
    },
    hasValidAdjustment: function () {
      if (this.currentLabelReport) {
        return NumberUtil.isPositiveInteger(this.currentLabelReport.adjustment) || NumberUtil.isNegativeInteger(this.currentLabelReport.adjustment)
      }
      return false
    },
    estimatesComplete: function () {
      let complete = false
      if (this.hasEstimates) {
        complete = true
        for (let labelReportEstimate of this.currentLabelReportEstimate.labelReportEstimates) {
          if (!NumberUtil.isZeroOrPositiveInteger(labelReportEstimate.estimate)) {
            complete = false
            break
          }
        }
      }
      return complete
    },
    total: function () {
      let sequenceContainer = this.currentLabelReport ? this.currentLabelReport : this.currentLabelReportTask ? this.currentLabelReportTask : null
      if (sequenceContainer) {
        let total = 0
        for (let seq of sequenceContainer.sequences) {
          let start = NumberUtil.isZeroOrPositiveInteger(seq.sequenceStart) ? Number(seq.sequenceStart) : -1
          let end = NumberUtil.isZeroOrPositiveInteger(seq.sequenceEnd) ? Number(seq.sequenceEnd) : -1
          if (start >= 0 && end >= start) {
            total += end - start + 1
          }
        }
        if (this.hasValidAdjustment) {
          total += Number(this.currentLabelReport.adjustment)
        }
        return total
      }
      return 0
    },
    saveOrderButtonDisabled: function () {
      return !this.currentLabelReportOrder || this.currentLabelReportOrder.categories.length === 0 || this.currentLabelReportOrder.field.id === 0 || this.currentLabelReportOrder.users.length === 0
    },
    canDeleteOrder: function () {
      return this.currentLabelReportOrder && this.currentLabelReportOrder.id > 0
    },
    labelReportEstimatesWithTotals: function () {
      let data = []
      if (this.labelReportEstimates && this.labelReportEstimates.length > 0) {
        let total = 0
        for (let labelReportEstimate of this.labelReportEstimates) {
          data.push(labelReportEstimate)
          if (labelReportEstimate.labelReportEstimates && labelReportEstimate.labelReportEstimates.length > 0) {
            for (let est of labelReportEstimate.labelReportEstimates) {
              total += est.estimate
            }
          }
        }
        data.push({
          type: 'total',
          value: total
        })
      }
      return data
    },
    bulkApproveDisabled: function () {
      if (this.labelReportTasksSelected) {
        for (let lrt of this.labelReportTasksSelected) {
          if (lrt.selected) {
            return false
          }
        }
      }
      return true
    },
    isValidTracking: function () {
      return NumberUtil.isZeroOrPositiveInteger(this.trackLabelNo)
    },
    canDeleteLabelReportEstimate: function () {
      return this.currentLabelReportEstimate && this.currentLabelReportEstimate.id > 0
    },
    fieldsWithoutEstimates: function () {
      let data = []
      if (this.fields) {
        for (let field of this.fields) {
          let exists = false
          if (this.labelReportEstimates) {
            for (let labelReportEstimate of this.labelReportEstimates) {
              if (field.id === labelReportEstimate.field.id) {
                exists = true
                break
              }
            }
          }
          if (!exists) {
            data.push(field)
          }
        }
      }
      return data
    },
    hasEstimates: function () {
      return this.currentLabelReportEstimate && this.currentLabelReportEstimate.labelReportEstimates.length > 0
    }
  },
  methods: {
    loadLabelReports () {
      this.trackingMode = false
      axios.get('/backend/rest/label_report/summary?category=' + this.filterCategory.id + '&supplier=' + this.filterSupplier.id + '&field=' + this.filterField.id + '&user=' + this.filterLabeller.id)
        .then(response => {
          this.labelReports = response.data
          this.initLabelReportsWithTotals()
        })
    },
    initLabelReportsWithTotals: function () {
      let labelReportsWithTotals = []
      if (this.labelReports && this.labelReports.length > 0) {
        let total = 0
        let subTotal = 0
        let fieldId = 0
        let multipleFields = false
        for (let labelReport of this.labelReports) {
          if (fieldId > 0 && labelReport.field.id !== fieldId) {
            labelReportsWithTotals.push({
              type: 'subTotal',
              value: subTotal
            })
            subTotal = 0
            multipleFields = true
          }
          subTotal += labelReport.total
          total += labelReport.total
          labelReportsWithTotals.push(labelReport)
          fieldId = labelReport.field.id
        }
        if (multipleFields) {
          labelReportsWithTotals.push({
            type: 'subTotal',
            value: subTotal
          })
        }
        labelReportsWithTotals.push({
          type: 'total',
          value: total
        })
        for (let i = 0; i < labelReportsWithTotals.length; i++) {
          labelReportsWithTotals[i].newSupplier = this.isNewSupplier(labelReportsWithTotals, i)
          labelReportsWithTotals[i].newField = this.isNewField(labelReportsWithTotals, i)
        }
      }
      this.labelReportsWithTotals = labelReportsWithTotals
    },
    loadLabelReportOrders () {
      axios.get('/backend/rest/label_report/order?supplier=' + this.filterSupplier.id + '&field=' + this.filterField.id + '&user=' + this.filterLabeller.id)
        .then(response => {
          this.labelReportOrders = response.data
        })
    },
    loadLabelReportTasks () {
      axios.get('/backend/rest/label_report/task/pendingApproval')
        .then(response => {
          let labelReportTasks = response.data
          let labelReportTasksSelected = []
          for (let lrt of labelReportTasks) {
            labelReportTasksSelected.push({
              id: lrt.id,
              task: lrt,
              selected: false
            })
          }
          this.labelReportTasksSelected = labelReportTasksSelected
          this.labelReportTasks = labelReportTasks
        })
    },
    loadLabelReportEstimates () {
      axios.get('/backend/rest/label_report/estimate?supplier=' + this.filterSupplier.id + '&field=' + this.filterField.id + '&category=' + this.filterCategory.id)
        .then(response => {
          this.labelReportEstimates = response.data
        })
    },
    loadCategories () {
      this.categories = []
      axios.get('/backend/rest/category')
        .then(response => {
          this.categories = response.data
        })
    },
    loadSuppliers () {
      this.suppliers = []
      axios.get('/backend/rest/supplier')
        .then(response => {
          this.suppliers = response.data
          this.suppliers.sort(function (f1, f2) {
            return f1.name.localeCompare(f2.name)
          })
        })
    },
    loadFields () {
      this.fields = []
      axios.get('/backend/rest/field' + (this.currentSupplier && this.currentSupplier.id > 0 ? '/supplier/' + this.currentSupplier.id : ''))
        .then(response => {
          this.fields = response.data
          this.fields.sort(function (f1, f2) {
            return f1.address.nameAndText.localeCompare(f2.address.nameAndText)
          })
        })
    },
    loadLabellers () {
      this.labellerUsers = []
      axios.get('/backend/rest/user/labeller')
        .then(response => {
          this.labellerUsers = response.data
          this.labellerUsersWithEmpty = JSON.parse(JSON.stringify(this.labellerUsers))
          this.labellerUsersWithEmpty.splice(0, 0, {
            id: 0,
            fullName: ''
          })
        })
    },
    loadFilterCategories () {
      axios.get('/backend/rest/category')
        .then(response => {
          this.filterCategories = response.data
          this.filterCategories.splice(0, 0, {
            id: 0,
            displayLabel: ''
          })
        })
    },
    loadFilterSuppliers () {
      axios.get('/backend/rest/supplier')
        .then(response => {
          let filterSuppliers = response.data
          filterSuppliers.splice(0, 0, {
            id: 0,
            name: ''
          })
          filterSuppliers.sort(function (f1, f2) {
            return f1.name.localeCompare(f2.name)
          })
          this.filterSuppliers = filterSuppliers
        })
    },
    loadFilterFields () {
      axios.get('/backend/rest/field')
        .then(response => {
          let filterFields = response.data
          filterFields.splice(0, 0, {
            id: 0,
            address: {
              nameAndText: ''
            }
          })
          filterFields.sort(function (f1, f2) {
            return f1.address.nameAndText.localeCompare(f2.address.nameAndText)
          })
          this.filterFields = filterFields
        })
    },
    loadFilterLabellers () {
      axios.get('/backend/rest/user/labeller')
        .then(response => {
          let filterLabellers = response.data
          filterLabellers.splice(0, 0, {
            id: 0,
            fullName: ''
          })
          filterLabellers.sort(function (f1, f2) {
            return f1.fullName.localeCompare(f2.fullName)
          })
          this.filterLabellers = filterLabellers
        })
    },
    selectLabelReportRow (item) {
      for (let labelReport of this.labelReports) {
        if (labelReport.id === item.id) {
          this.currentLabelReport = labelReport
          for (let supplier of this.suppliers) {
            if (supplier.id === labelReport.supplier.id) {
              this.currentSupplier = supplier
              break
            }
          }
          break
        }
      }
      this.loadFields()
    },
    selectLabelReportOrderRow (item) {
      this.loadLabellers()
      for (let labelReportOrder of this.labelReportOrders) {
        if (labelReportOrder.id === item.id) {
          this.currentLabelReportOrder = labelReportOrder
          for (let supplier of this.suppliers) {
            if (supplier.id === labelReportOrder.supplier.id) {
              this.currentSupplier = supplier
              break
            }
          }
          break
        }
      }
      this.loadFields()
    },
    selectLabelReportTaskRow (task) {
      for (let labelReportTask of this.labelReportTasks) {
        if (labelReportTask.id === task.id) {
          this.currentLabelReportTask = labelReportTask
          break
        }
      }
    },
    selectLabelReportEstimateRow (item) {
      this.newLabelReportEstimate = false
      for (let labelReportEstimate of this.labelReportEstimates) {
        if (labelReportEstimate.field.id === item.field.id) {
          this.currentLabelReportEstimate = labelReportEstimate
          for (let supplier of this.suppliers) {
            if (supplier.id === labelReportEstimate.supplier.id) {
              this.currentSupplier = supplier
              break
            }
          }
          break
        }
      }
      this.loadFields()
    },
    showLabelReports () {
      this.loadLabelReports()
      this.view = 'LABEL_REPORT'
    },
    showLabelReportTasks () {
      this.loadLabelReportTasks()
      this.loadLabelReportOrders()
      this.view = 'TASK'
    },
    showLabelReportEstimates () {
      this.loadLabelReportEstimates()
      this.view = 'ESTIMATE'
    },
    print () {
      let filteredItems = this.$refs.labelReports.filteredItems
      let labelReportIds = []
      for (let labelReport of filteredItems) {
        if (labelReport.id) {
          labelReportIds.push(labelReport.id)
        }
      }
      let params = 'labelReports=' + labelReportIds.join(',')
      axios.post('/backend/print/labelReports.xhtml', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/pdf' }), 'Label reports.pdf')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Label reports.pdf')
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    create () {
      this.currentSupplier = null
      this.loadCategories()
      this.loadFields()
      this.currentLabelReport = {
        id: 0,
        field: { id: 0 },
        category: { id: 0 },
        adjustment: '',
        sequences: [
          {
            id: 0,
            sequenceStart: '',
            sequenceEnd: ''
          }
        ]
      }
    },
    createOrder () {
      this.currentSupplier = null
      this.loadFields()
      this.loadCategories()
      this.currentLabelReportOrder = {
        id: 0,
        field: { id: 0 },
        categories: [],
        users: []
      }
    },
    addSequence () {
      let sequenceContainer = this.currentLabelReport ? this.currentLabelReport : this.currentLabelReportTask ? this.currentLabelReportTask : null
      sequenceContainer.sequences.push(
        {
          id: -sequenceContainer.sequences.length,
          sequenceStart: '',
          sequenceEnd: ''
        }
      )
    },
    save () {
      if (this.currentLabelReport) {
        if (this.hasValidAdjustment) {
          let sequences = []
          for (let seq of this.currentLabelReport.sequences) {
            let start = NumberUtil.isZeroOrPositiveInteger(seq.sequenceStart) ? Number(seq.sequenceStart) : -1
            let end = NumberUtil.isZeroOrPositiveInteger(seq.sequenceEnd) ? Number(seq.sequenceEnd) : -1
            if (start >= 0 && end >= start) {
              sequences.push(seq)
            }
          }
          this.currentLabelReport.sequences = sequences
        }
        delete this.currentLabelReport.newSupplier
        delete this.currentLabelReport.newField
        axios.post('/backend/rest/label_report', this.currentLabelReport)
          .then(response => {
            this.loadLabelReports()
          })
          .catch(error => {
            console.log(error.response.data.message)
          })
        this.currentLabelReport = null
      } else if (this.currentLabelReportTask) {
        axios.post('/backend/rest/label_report/task', this.currentLabelReportTask)
          .then(response => {
            this.loadLabelReportTasks()
          })
          .catch(error => {
            console.log(error.response.data.message)
          })
        this.currentLabelReportTask = null
      }
    },
    delete () {
      axios.delete('/backend/rest/label_report/' + this.currentLabelReport.id)
        .then(response => {
          this.loadLabelReports()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteDialog = false
      this.currentLabelReport = null
    },
    cancel () {
      this.currentLabelReport = null
      if (!this.trackingMode) {
        this.loadLabelReports()
      }
    },
    canDeleteSequence (index) {
      if (this.currentLabelReport) {
        return this.currentLabelReport.sequences.length > 1
      } else if (this.currentLabelReportTask) {
        return this.currentLabelReportTask.sequences.length > 0
      }
      return false
    },
    canDeleteEstimate (index) {
      if (this.currentLabelReportEstimate) {
        return this.currentLabelReportEstimate.labelReportEstimates.length > 1
      }
      return false
    },
    deleteSequence (index) {
      let sequenceContainer = this.currentLabelReport ? this.currentLabelReport : this.currentLabelReportTask ? this.currentLabelReportTask : null
      sequenceContainer.sequences.splice(index, 1)
    },
    deleteEstimate (index) {
      this.currentLabelReportEstimate.labelReportEstimates.splice(index, 1)
    },
    saveOrder () {
      axios.post('/backend/rest/label_report/order', this.currentLabelReportOrder)
        .then(response => {
          this.loadLabelReportOrders()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentLabelReportOrder = null
    },
    deleteOrder () {
      axios.delete('/backend/rest/label_report/order/' + this.currentLabelReportOrder.id)
        .then(response => {
          this.loadLabelReportOrders()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteOrderDialog = false
      this.currentLabelReportOrder = null
    },
    cancelOrder () {
      this.currentLabelReportOrder = null
      this.loadLabelReportTasks()
      this.loadLabelReportOrders()
    },
    approveTask () {
      axios.post('/backend/rest/label_report/task/approve', this.currentLabelReportTask)
        .then(response => {
          this.loadLabelReportTasks()
          this.loadLabelReports()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentLabelReportTask = null
    },
    unlockTask () {
      this.currentLabelReportTask.completed = false
      this.currentLabelReportTask.completedTimestamp = null
      this.save()
    },
    cancelTask () {
      this.currentLabelReportTask = null
      this.loadLabelReportTasks()
      this.loadLabelReports()
    },
    itemSelected (items, item) {
      if (item && items && items instanceof Array) {
        for (let i of items) {
          if (i instanceof Object) {
            if (i.id === item.id) {
              return true
            }
          } else if (i === item.id) {
            return true
          }
        }
      }
      return false
    },
    confirmBulkApprove () {
      this.confirmBulkApproveDialog = true
    },
    async bulkApprove () {
      for (let lrt of this.labelReportTasksSelected) {
        if (lrt.selected) {
          await axios.post('/backend/rest/label_report/task/approve', lrt.task)
            .catch(error => {
              console.log(error.response.data.message)
            })
        }
      }
      this.loadLabelReportTasks()
      this.loadLabelReports()
      this.confirmBulkApproveDialog = false
    },
    openTrackLabelDialog () {
      this.trackLabelCategory = null
      this.trackLabelNo = null
      this.trackLabelNoError = null
      this.trackLabelDialog = true
      this.loadLabelReports()
    },
    trackLabel () {
      this.trackLabelNoError = null
      this.trackingMode = false
      axios.get('/backend/rest/label_report/track?category=' + (this.trackLabelCategory ? this.trackLabelCategory.id : 0) + '&labelNumber=' + this.trackLabelNo)
        .then(response => {
          let labelReports = response.data
          if (labelReports && labelReports.length > 0) {
            if (labelReports.length === 1) {
              this.selectLabelReportRow(labelReports[0])
            } else {
              this.trackingMode = true
              this.labelReports = labelReports
            }
            this.trackLabelDialog = false
          } else {
            this.trackLabelNoError = 'Label number was not found'
          }
        })
    },
    createEstimate () {
      this.currentSupplier = null
      this.loadFields()
      this.loadCategories()
      this.newLabelReportEstimate = true
      this.selectedCategories = []
      this.currentLabelReportEstimate = {
        supplier: { id: 0 },
        field: { id: 0 },
        labelReportEstimates: []
      }
    },
    cancelEstimate () {
      for (let i = this.currentLabelReportEstimate.labelReportEstimates.length - 1; i >= 0; i--) {
        let estimate = this.currentLabelReportEstimate.labelReportEstimates[i]
        if (!estimate.category) {
          this.deleteEstimate(i)
        }
      }
      this.loadLabelReportEstimates()
      this.currentLabelReportEstimate = null
    },
    addEstimate () {
      this.currentLabelReportEstimate.labelReportEstimates.push(
        {
          id: -this.currentLabelReportEstimate.labelReportEstimates.length,
          supplier: this.currentSupplier,
          field: this.currentLabelReportEstimate.field,
          category: null,
          estimate: ''
        }
      )
    },
    deleteEstimates () {
      axios.delete('/backend/rest/label_report/estimate/' + this.currentLabelReportEstimate.field.id)
        .then(response => {
          this.loadLabelReportEstimates()
          this.confirmDeleteEstimateDialog = false
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentLabelReportEstimate = null
    },
    saveEstimate () {
      axios.post('/backend/rest/label_report/estimate', this.currentLabelReportEstimate)
        .then(response => {
          this.loadLabelReportEstimates()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentLabelReportEstimate = null
    },
    createEstimates () {
      let estimateId = 0
      for (let cat of this.selectedCategories) {
        this.currentLabelReportEstimate.labelReportEstimates.push(
          {
            id: estimateId,
            supplier: this.currentSupplier,
            field: this.currentLabelReportEstimate.field,
            category: cat,
            estimate: ''
          }
        )
        estimateId--
      }
    },
    isNewSupplier (labelReportsWithTotals, index) {
      if (labelReportsWithTotals && labelReportsWithTotals.length > 0 && index > 0 && index < labelReportsWithTotals.length) {
        return (labelReportsWithTotals[index].type && !labelReportsWithTotals[index - 1].type) || (!labelReportsWithTotals[index].type && labelReportsWithTotals[index - 1].type) || (!labelReportsWithTotals[index].type && labelReportsWithTotals[index].supplier.id !== labelReportsWithTotals[index - 1].supplier.id)
      }
      return true
    },
    isNewField (labelReportsWithTotals, index) {
      if (labelReportsWithTotals && labelReportsWithTotals.length > 0 && index > 0 && index < labelReportsWithTotals.length) {
        return (labelReportsWithTotals[index].type && !labelReportsWithTotals[index - 1].type) || (!labelReportsWithTotals[index].type && labelReportsWithTotals[index - 1].type) || (!labelReportsWithTotals[index].type && labelReportsWithTotals[index].field.id !== labelReportsWithTotals[index - 1].field.id)
      }
      return true
    },
    labelReportOrderRowClass (labelReportOrder) {
      return 'selectable' + (labelReportOrder && labelReportOrder.completed ? ' completed' : '')
    },
    labelReportEstimateRowClass (labelReportEstimate) {
      return 'selectable' + (labelReportEstimate && labelReportEstimate.labelled ? ' labelled' : '')
    },
    getLabelReportEstimateTotal (labelReportEstimate) {
      let totalValue = 0
      for (let e of labelReportEstimate.labelReportEstimates) {
        totalValue += e.estimate
      }
      return totalValue
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
  .labelReportTaskTable {
    margin-bottom: 20px;
  }
  tr.subTotal td {
    font-weight: bold;
    color: rgba(0, 0, 0, .54);
  }
  div.subTotal {
    font-weight: bold;
    color: rgba(0, 0, 0, .54);
    padding-bottom: 10px;
  }
  div.subTotalValue {
    border-top: 1px solid rgba(0, 0, 0, .54);
    font-weight: bold;
    color: rgba(0, 0, 0, .54);
    padding-bottom: 10px;
  }
  tr.total td {
    font-weight: bold;
    color: rgba(0, 0, 0, .54)
  }
  .labelReportTask .v-input--checkbox {
    padding: 0 !important;
    height: 24px !important;
  }
  tr.completed,
  tr.labelled {
    color: rgba(0, 0, 0, .4);
    background-color: rgba(0, 77, 64, .15);
  }
  tr.completed:hover,
  tr.labelled:hover {
    color: rgba(0, 0, 0, .87) !important;
    background-color: rgba(0, 77, 64, .25) !important;
  }
  table.v-table tbody tr td.category {
    width: 22px !important;
    padding-left: 15px !important;
    padding-right: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/LabelReport.vue